import { useRouter } from "next/compat/router";
import { useEffect } from "react";
import { useCloseUserListManagerElements } from "@hooks/use-userlists";
import AddedToWishlistToast from "./AddedToWishlistToast";
import AddedToUserListToast from "./AddedToUserListToast";
import AddToUserListOffcanvas from "./AddToUserListOffcanvas";
import AuthOffcanvasPriorToLikeProduct from "./AuthOffcanvasPriorToLikeProduct";

function UserListManager() {
  const router = useRouter();
  const closeUserListManagerElements = useCloseUserListManagerElements();

  useEffect(() => {
    function handleRouteChangeStart() {
      closeUserListManagerElements();
    }

    router.events.on("routeChangeStart", handleRouteChangeStart);

    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
    };
  }, [closeUserListManagerElements, router.events]);

  return (
    <>
      <AddedToWishlistToast />
      <AddedToUserListToast />
      <AddToUserListOffcanvas />
      <AuthOffcanvasPriorToLikeProduct />
    </>
  );
}

export default UserListManager;
